import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "answers" }

import { ref } from 'vue'
import Modal from '@/components/Modal.vue'
import { QuizzIllustrationUserAnswer, QuizzSentence } from '@/types/Quizz'
import QuizzIllustrationCard from './QuizzIllustrationCard.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    currentUserAnswers: null,
    sentence: null
  },
  emits: ['on-card-click'],
  setup(__props: any, { expose, emit }) {

const props = __props as {
  currentUserAnswers: QuizzIllustrationUserAnswer[]
  sentence: QuizzSentence
}





const quizzIllustrationMobileModal = ref<InstanceType<typeof Modal> | null>(
  null
)

const currentTargetId = ref<number | null>(null)

function isAnswerUsedForId(id: number) {
  const index = props.currentUserAnswers.findIndex(
    (userAnswer) => userAnswer.answerId === id
  )

  return index !== -1
}

function onCardClick(id: number) {
  emit('on-card-click', currentTargetId.value, id)
  hide()
}

async function show(targetId: number) {
  quizzIllustrationMobileModal.value?.show()
  currentTargetId.value = targetId
}

async function hide() {
  quizzIllustrationMobileModal.value?.hide()
}

expose({
  show,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "quizzIllustrationMobileModal",
    ref: quizzIllustrationMobileModal,
    class: "modal-quizz-illustration-mobile",
    title: _ctx.$t('quizz.mobileModal.title')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.sentence.answers, (answer) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "card",
            key: answer.id
          }, [
            _createVNode(QuizzIllustrationCard, {
              id: answer.id,
              "is-draggable-element": false,
              answer: answer.answer,
              onOnCardClick: onCardClick,
              disabled: isAnswerUsedForId(answer.id)
            }, null, 8, ["id", "answer", "disabled"])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})